/**
 * API client for system status endpoints.
 * Routes: /api/mgmt/status
 */

import { apiFetch } from './client';

export interface ModelHealth {
  model: string;
  status: string;
}

export interface HealthStatus {
  gateway: string;
  database: string;
  cache: string;
  models: ModelHealth[];
  modelsHealthy: boolean;
  version: string;
  uptime: string;
  uptimeMs: number;
  checkedAt: string;
}

export async function getHealthStatus(token: string): Promise<HealthStatus> {
  return apiFetch<HealthStatus>('/api/mgmt/status', token);
}
